import { Col, Layout } from "antd";
import styled from "styled-components";
const { Content } = Layout;

const Layoutstyled = styled(Layout)`
  min-height: 100vh !important;
`;

const Contentstyled = styled(Content)`
  padding: 0 50px;
  margin: 5vh 0;
`;

const ColShadow = styled(Col)`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 2vh;
`;

const SpanBlue = styled.span`
  font-size: 13px;
  font-weight: bold;
  color: #0000FE;
  cursor: pointer;
`;

export { ColShadow, Contentstyled, Layoutstyled, SpanBlue };
